import React from "react";
import "./About.css";

const About = () => {
  return (
    <div className="about-container">
      <h2 className="about-title">About AntBet FOOTBALL</h2>

      <div className="about-card">
        <p className="about-text">
          <strong>AntBet FOOTBALL</strong> ni jukwaa la kisasa la michezo ya
          kubashiri lililoundwa kuwapa watumiaji uzoefu salama, wa haraka
          na wa kuaminika katika ulimwengu wa betting. Jukwaa letu limeidhinishwa
          na kukubalika kutumika tarehe <strong>22/12/2025</strong>.
        </p>

        <p className="about-text">
          Mfumo wetu unaruhusu watumiaji kucheza kwa kutumia{" "}
          <strong>TSH</strong> na <strong>USDT</strong>, kushiriki bonuses
          mbalimbali, pamoja na kufurahia mfumo wa kipekee wa ushindi.
        </p>
      </div>

      {/* ✅ SEHEMU MPYA ULIYOOMBA */}
      <div className="about-card">
        <h3 className="about-subtitle">Ufafanuzi Muhimu kwa Wanachama</h3>
        <p className="about-text">
          Hivyo basi wapendwa wa <strong>AntBet</strong>, tunapenda kuwafahamisha
          kuwa <strong>AntBet FOOTBALL</strong> ina makao yake makuu
          <strong> London, Uingereza</strong>. Hii ndiyo sababu kuu inayofanya
          mfumo wetu kuanza kwa kutumia <strong>USDT</strong> kama njia ya
          malipo ya kimataifa yenye usalama na uwazi wa hali ya juu.
        </p>

        <p className="about-text">
          Aidha, kwa kuzingatia ukuaji wa soko la ndani, mameneja wetu
          wa Kitanzania wamefanikiwa kudhamini na kuendeleza mfumo wa
          <strong> Tanzania Shilling (TSH)</strong> kwa uwazi zaidi,
          ili kuwapa watumiaji wetu uhuru wa kuchagua njia rahisi na
          salama ya kucheza kulingana na mahitaji yao.
        </p>

        <p className="about-text">
          Hivyo basi, uwe huru kutumia <strong>AntBet FOOTBALL</strong> kwa
          kujiamini, kwani mifumo yote inaendeshwa kwa uwazi, usalama
          na kwa kuzingatia maslahi ya mteja.
        </p>
      </div>

      <div className="about-card">
        <h3 className="about-subtitle">Huduma Zetu</h3>
        <ul className="about-list">
          <li>⚽ Football Betting</li>
          <li>🎁 First & Second Deposit Bonuses</li>
          <li>📆 Weekly Bonus</li>
          <li>💳 Deposit & Withdrawal Haraka</li>
          <li>👥 Mfumo wa Team / Network</li>
          <li>📞 Customer Service</li>
          <li>🔒 Usalama wa Akaunti</li>
        </ul>
      </div>

      <div className="about-card">
        <h3 className="about-subtitle">Dhamira Yetu</h3>
        <p className="about-text">
          Dhamira ya <strong>AntBet FOOTBALL</strong> ni kujenga jukwaa
          la betting lenye uwazi, haki na malipo ya wakati kwa kila mtumiaji.
        </p>
      </div>

      <div className="about-card">
        <h3 className="about-subtitle">Malengo Yetu</h3>
        <ul className="about-list">
          <li>
            ✔ Ni kuhakikisha mfumo wa uwakika unaosaidia vijana wote kukuza
            uelewa sahihi wa betting, kucheza kwa busara na kwa mipango,
            pamoja na kuepuka matumizi mabaya ya fedha au kuweka rehani
            zisizo sahihi.
          </li>
        </ul>
      </div>

      <div className="about-card">
        <h3 className="about-subtitle">Maadili Yetu</h3>
        <ul className="about-list">
          <li>✔ Uaminifu</li>
          <li>✔ Uwajibikaji</li>
          <li>✔ Haki kwa Mteja</li>
          <li>✔ Teknolojia ya Kisasa</li>
        </ul>
      </div>

      <div className="about-footer">
        <p>© {new Date().getFullYear()} AntBet FOOTBALL</p>
        <p>All Rights Reserved</p>
      </div>
    </div>
  );
};

export default About;